import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Portalled to document.body. The overlay is position:fixed and centres itself,
 * but fixed resolves against the nearest ancestor carrying transform / filter /
 * backdrop-filter / will-change rather than the viewport — and several cards,
 * dropdowns and blurred panels here do. Mounted in place it centred inside
 * whatever box it sat in, and .popup-content's 25% width was taken from that
 * box too, which is why it came out small, off to the right and overflowing.
 */
const ErrorPopup = ({onClose,message}) => {
  return ReactDOM.createPortal(
    <div className="popup">
    <div className="popup-content">
      <div className="text-end">
      <button   className="bg-transparent border-0"onClick={onClose}><i className="bi bi-x-circle"></i></button>
      </div>
      <div className="text-center mt-2">
        <p className="mb-2 text-danger ev-fs-20"><i className="bi bi-exclamation-circle"></i></p>
        <p className="ev-fs-12 ev-bold-reg" >{message}</p>
      </div>
    </div>
  </div>,
    document.body
  );
};


export default ErrorPopup;
